var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { STORE_ACTIONS, ACTION_KEYS } from "../Utils/constants";
var IDLE = { status: "idle", error: null };
var isLoading = function (map) {
    return Object.values(map).some(function (s) { return s.status === "loading"; });
};
export var createUiStatusSlice = function (set) { return ({
    actionStatus: Object.fromEntries(Object.values(ACTION_KEYS).map(function (key) { return [key, __assign({}, IDLE)]; })),
    isAnyLoading: false,
    globalError: null,
    setActionStart: function (actionKey, requestId) {
        set(function (state) {
            var _a;
            var next = __assign(__assign({}, state.actionStatus), (_a = {}, _a[actionKey] = {
                status: "loading",
                error: null,
                requestId: requestId !== null && requestId !== void 0 ? requestId : null,
                timestamp: Date.now(),
            }, _a));
            return {
                actionStatus: next,
                isAnyLoading: isLoading(next),
                globalError: null,
            };
        }, false, "".concat(STORE_ACTIONS.UI_ACTION_START, "/").concat(actionKey));
    },
    setActionSuccess: function (actionKey, requestId) {
        set(function (state) {
            var _a;
            // Discard if a newer request has already started
            var current = state.actionStatus[actionKey];
            if (requestId && (current === null || current === void 0 ? void 0 : current.requestId) !== requestId)
                return state;
            var next = __assign(__assign({}, state.actionStatus), (_a = {}, _a[actionKey] = {
                status: "success",
                error: null,
                requestId: requestId !== null && requestId !== void 0 ? requestId : null,
                timestamp: Date.now(),
            }, _a));
            return {
                actionStatus: next,
                isAnyLoading: isLoading(next),
            };
        }, false, "".concat(STORE_ACTIONS.UI_ACTION_SUCCESS, "/").concat(actionKey));
    },
    setActionError: function (actionKey, error, code, requestId) {
        set(function (state) {
            var _a;
            // Discard if a newer request has already started
            var current = state.actionStatus[actionKey];
            if (requestId && (current === null || current === void 0 ? void 0 : current.requestId) !== requestId)
                return state;
            var errorState = {
                status: "error",
                error: error,
                code: code !== null && code !== void 0 ? code : null,
                requestId: requestId !== null && requestId !== void 0 ? requestId : null,
                timestamp: Date.now(),
            };
            var next = __assign(__assign({}, state.actionStatus), (_a = {}, _a[actionKey] = errorState, _a));
            return {
                actionStatus: next,
                isAnyLoading: isLoading(next),
                globalError: errorState,
            };
        }, false, "".concat(STORE_ACTIONS.UI_ACTION_ERROR, "/").concat(actionKey));
    },
    clearActionStatus: function (actionKey) {
        set(function (state) {
            var _a;
            var current = state.actionStatus[actionKey];
            var next = __assign(__assign({}, state.actionStatus), (_a = {}, _a[actionKey] = __assign({}, IDLE), _a));
            var shouldClearGlobalError = (current === null || current === void 0 ? void 0 : current.status) === "error" &&
                state.globalError != null &&
                state.globalError.requestId === current.requestId &&
                state.globalError.timestamp === current.timestamp;
            return {
                actionStatus: next,
                isAnyLoading: isLoading(next),
                globalError: shouldClearGlobalError ? null : state.globalError,
            };
        }, false, "".concat(STORE_ACTIONS.UI_ACTION_CLEAR, "/").concat(actionKey));
    },
    clearAllErrors: function () {
        set(function (state) { return ({
            actionStatus: Object.fromEntries(Object.entries(state.actionStatus).map(function (_a) {
                var k = _a[0], v = _a[1];
                return [
                    k,
                    v.status === "error"
                        ? __assign(__assign({}, IDLE), { code: null, requestId: null, timestamp: undefined }) : v,
                ];
            })),
            globalError: null,
        }); }, false, STORE_ACTIONS.UI_CLEAR_ALL_ERRORS);
    },
}); };
